import React from "react"
import { Heading } from "frontend/components/text"
import { ProgressBar } from "frontend/components/progress"
import t from "frontend/utils/translations"

import styles from "./DiscoverabilityScore.module.css"

const WEIGHTING = {
  title: 10,
  description: 40,
  category: 10,
  tags: 40,
}

const calculateTitleScore = (title) => {
  if (title && title.length > 5) {
    return WEIGHTING.title
  }

  return 0
}

const calculateDescriptionScore = (description) => {
  if (description && description.length > 200) {
    return WEIGHTING.description
  }

  if (description && description.length > 160) {
    return (WEIGHTING.description / 4) * 3
  }

  if (description && description.length > 110) {
    return (WEIGHTING.description / 4) * 2
  }

  if (description && description.length > 60) {
    return WEIGHTING.description / 4
  }

  return 0
}

const calculateCategoryScore = (category) => {
  if (category) {
    return WEIGHTING.category
  }

  return 0
}

const calculateTagScore = (tags) => {
  if (tags && tags.length >= 20) {
    return WEIGHTING.tags
  }

  if (tags && tags.length > 10) {
    return (WEIGHTING.tags / 4) * 3
  }

  if (tags && tags.length > 5) {
    return (WEIGHTING.tags / 4) * 2
  }

  if (tags && tags.length > 2) {
    return WEIGHTING.tags / 4
  }

  return 0
}

const calculateDiscoverability = (values) => {
  if (values.get("privacy") !== "public") {
    return 0
  }

  const titleScore = calculateTitleScore(values.get("title"))
  const descriptionScore = calculateDescriptionScore(values.get("description"))
  const tagScore = calculateTagScore(values.get("tags"))
  const categoryScore = calculateCategoryScore(values.get("category"))

  return titleScore + descriptionScore + tagScore + categoryScore
}

const DiscoverabilityScore = ({ values, className }) => {
  return (
    <div className={`${styles.container} ${className}`}>
      <Heading size={4}>{t("upload.form.discoverability_score.label")}</Heading>
      <ProgressBar percent={calculateDiscoverability(values)} />
      <p className={styles.explanation}>{t("upload.form.discoverability_score.description")}</p>
    </div>
  )
}

export default DiscoverabilityScore
